const pushToDataLayer = (eventName, data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...data
  });
};

const eventNames = {
  cta: "lp_torcedores_click_cta",
  faq: "lp_torcedores_click_faq",
  partner: "lp_torcedores_click_parceiros",
  contact: "contact"
};

export const handleCTAClick = () => {
  pushToDataLayer(eventNames.cta);
};

export const handleFAQClick = question => {
  pushToDataLayer(eventNames.faq, {
    pergunta: question
  });
};

export const handlePartnerClick = () => {
  pushToDataLayer(eventNames.partner);
};

export const handleContactSend = (
  subject,
  zipCode,
  phone,
  email,
  name,
  cpf,
  message
) => {
  pushToDataLayer(eventNames.contact, {
    formType: subject,
    formCep: zipCode,
    formPhone: phone,
    formEmail: email,
    formName: name,
    formMsg: message,
    formCpf: cpf
  });
};
